export const TOP_TIP = 'toptip' // 顶部提示与
export const SHOP_ASSISTANT = 'shop_assistant' // 开店助手
export const COMMON_FUNCTION = 'common_function' // 常用功能
export const YESTERDAY_DATA = 'yesterday_data' // 昨日数据
export const BUSINESS_COLLEGE = 'business_college' // 商学院
export const ONLINE_STORE = 'online_store' // 店铺产品-线上店铺
export const UNPAID = 'unpaid' // 店铺产品-未付费
export const FOUR_ROLE = 'four_role' // 店铺产品-四大商家
export const PRO = 'pro' // 店铺产品-旗舰版/尊享版
export const SYSTEM_NOTICE = 'system_notice' // 系统公告
export const PLATFORM_ACTIVITY = 'platform_activity' // 平台活动
export const CONTACT_US = 'contact_us' // 联系我们
export const STORE_INFO = 'store_info' // 店铺信息
export const STORE_OVERVIEW = 'store_overview' // 实时概况  done
